import { memo } from 'react'
import { useAppDispatch } from 'store'
import { useIsLogin } from 'store/account/hooks'
import { updateHideOtherPairs } from 'store/orderbook/actions'
import { useHideOtherPairs } from 'store/orderbook/hooks'
import { Button, Checkbox, FormControlLabel, styled } from '@mui/material'

const CheckWrap = styled(Button)`
  flex-direction: row;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  line-height: 14px;
  padding: 2px 8px;
  cursor: pointer;

  ${(props) => props.theme.breakpoints.down('md')} {
    padding: 2px 0;
  }
`
const StyledFormControlLabel = styled(FormControlLabel)`
  margin-left: 0;
  .MuiFormControlLabel-label {
    font-size: 14px;
    line-height: 1.4;
    color: ${(props) => props.theme.color.text50};
  }
  .Mui-checked {
    .MuiSvgIcon-root {
      color: rgba(160, 238, 9, 1) !important;
    }
  }
`
const StyledCheckbox = styled(Checkbox)`
  padding: 0;
  margin-right: 2px;
  .MuiSvgIcon-root {
    width: 17px;
    height: 17px;
    color: #7b8891;
  }
`

export const HideOtherPairs = memo(() => {
  const dispatch = useAppDispatch()
  const isLogin = useIsLogin()
  const hideOtherPairs = useHideOtherPairs()

  if (!isLogin) return null

  return (
    <CheckWrap>
      <StyledFormControlLabel
        control={<StyledCheckbox />}
        label={`Hide Other Pairs`}
        defaultChecked={hideOtherPairs}
        checked={hideOtherPairs}
        onChange={(e: any) => dispatch(updateHideOtherPairs(e.target.checked))}
      />
    </CheckWrap>
  )
})
